import React from 'react';
import 'card-pattern/dist/main.css';
import { adminLandingCards, LandingCard } from '../../../../config/landingCards';
import ScrollToTopBtn from '../../../../components/common/ScrollToTopBtn';
import { useAppSelector } from '../../../../store/hooks';
import { trackButtonClick } from '../../../../services/analytics';

const AdminLandingPage: React.FC = () => {
  const { adminProfile } = useAppSelector((state) => state.profile);
  const groupName = adminProfile?.groupName;
  console.log('AdminLandingPage - groupName:', groupName);
  
  // Filter out canned responses card if user is view-only
  const filteredCards = adminLandingCards.filter((card) => {
    if (groupName === 'epf.WorkforceRetrieverViewOnlyUser' && 
        card.title === 'Canned responses') {
      return false;
    }
    return true;
  });

  return (
    <div className="min-h-[70vh] lg:!mx-[160px] mx-5!">
      <div className="padding-bottom-2u margin-top-4u">
        <h1 className="greeting">Workplace development administration</h1>
  <p className="p3 -book mt-1">Manage your application and reimbursements.</p>
      </div>
      <div className="!mt-[6px] mb-12">
        <h2 className="h2">What would you like to do here?</h2>
  <p className="p3 -book mt-2">Please select one of the following below.</p>
      </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 !gap-x-4 gap-y-8 margin-top-4u">
        {filteredCards.map((card: LandingCard, idx: number) => (
          <fieldset
            key={card.title}
            className="ds-card"
            data-ds-theme="vessel"
            data-ds-variant="thumbnail"
            data-ds-version="2"
            aria-labelledby={`card-${idx}-title`}
          >
            <div className="ds-card__image">
              <img src={card.icon} alt="card icons" width="44" height="44" />
            </div>
            <div className="ds-card__content">
              <div className="p3 -medium" id={`card-${idx}-title`}>
                {card.title}
              </div>
              <div className="ds-card__link-container mt-4">
                <div className="ds-card__text-link" style={{fontSize:'16px'}}>
                  <a 
                    href={card.link} 
                    className="inline-link medium no-underline!"
                    onClick={() => {
                      console.log(`📊 Analytics: Admin card clicked - ${card.title}`);
                      trackButtonClick(card.linkText ?? 'Open', 'admin-landing-card', { cardTitle: card.title });
                    }}
                  >
                    {card.linkText ?? 'Open'}
                  </a>
                </div>
              </div>
            </div>
          </fieldset>
        ))}
      </div>
      <ScrollToTopBtn/>
    </div>
  );
};

export default AdminLandingPage;
